import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { EarOff, Flame, ShieldAlert } from 'lucide-react';
export function WhyItFails() {
  const reasons = [{
    icon: <EarOff size={28} data-id="element-246" />,
    title: 'Razonar durante la crisis falla',
    description: 'Porque la amígdala de tu hijo ha secuestrado su capacidad de escucha; es biológicamente imposible que te entienda.'
  }, {
    icon: <Flame size={28} data-id="element-247" />,
    title: 'Gritar para recuperar el control',
    description: 'Solo añade combustible al fuego, activando el modo de supervivencia extrema en el niño.'
  }, {
    icon: <ShieldAlert size={28} data-id="element-248" />,
    title: "Los 'tiempos fuera' tradicionales",
    description: 'Generan aislamiento y resentimiento, rompiendo el vínculo en el momento que más necesitan sentir seguridad.'
  }];
  return <section className="py-24 bg-sage-700 text-white relative overflow-hidden" data-id="element-249">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-250"></div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-251">
        <FadeIn data-id="element-252">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-253">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-cream" data-id="element-254">
              Por qué lo que has intentado hasta ahora no funciona
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-255">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-256">
              <div className="bg-sage-600/50 border border-sage-500/30 p-8 rounded-2xl h-full backdrop-blur-sm" data-id="element-257">
                <div className="w-14 h-14 rounded-full bg-terracotta/20 text-terracotta-light flex items-center justify-center mb-6" data-id="element-258">
                  {reason.icon}
                </div>
                <h3 className="text-xl font-semibold mb-4 text-cream" data-id="element-259">
                  {reason.title}
                </h3>
                <p className="text-sage-100 leading-relaxed opacity-90" data-id="element-260">
                  {reason.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}